// extracted by mini-css-extract-plugin
export default {"input":"FloSearchBox_input__Az8Mi","root":"FloSearchBox_root__fwxb5","icon":"FloSearchBox_icon__rRYpm"};